import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AuthService } from 'app/core/security/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthResponse } from '../api/auth-response.model';
import { CookieService } from 'app/shared/services/cookie.service';
import { environment } from 'environments/environment';
import { ApplicationService } from 'app/shared/services/application.service';
import { ApiInfo } from 'app/shared/models/api-info.model';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '../../../../../node_modules/@angular/forms';
import { ReactiveFormHelperService } from 'app/shared/helpers/reactive-form-helper.service';
import { UserContactListService } from 'app/modules/contacts/services/user-contact-list.service';
import { UserCompanyLookupDataModel } from 'app/modules/contacts/models/user-company-lookup-data.model';
import { UserListContainerService } from 'app/modules/configuration/user-list-page/user-list-container/user-list-container.service';
import { ApiAuthService } from '../api/api-auth.service';
import { SwitchCompanyLoginModel } from 'app/layout/components/switch-company-login/switch-company-login.model';
import { CompanyProductListService } from 'app/modules/my-services/services/company-product-list.service';
import { UsersService } from 'app/modules/user-management/services/users.service';
// TODO move to shared
@Component({ standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isSigningIn: boolean = false;
  isError: boolean = false;
  serverErrorMessage: string  = '';
  loginInfo: string = "";
  appVersion = 'unknown build number';
  apiInfo: ApiInfo = new ApiInfo();

  companyId: number = -1;
  userId: number = -1;

  showFirstCard = true;
  showAuthCard = false;
  showCompanyCard = false;

  displayPasswordReset: boolean = true;

  userContactsLookupData: any[] = [];
  currentSelectedMainContactId: number;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: ApplicationService,
    private cookieService: CookieService,
    private formHelperService: ReactiveFormHelperService,
    private contactService: UserContactListService,
    private vcr: ViewContainerRef,
    private userListService: UserListContainerService,
    private apiAuth: ApiAuthService,
    private companyProductListService: CompanyProductListService,
    private usersService: UsersService
  ) {
    this.dataForm = fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  dataForm: FormGroup;

  ngOnInit() {
    this.appVersion = environment.buildLabel;

    this.appService.getBuildVersion().then((apiInfo: ApiInfo) => {
      this.apiInfo = apiInfo;
    });

    let autoLoginGuid;
    this.route.params.subscribe((params) => {
      autoLoginGuid = params['uniqueIdentifier'];
    });

    if (autoLoginGuid) {
      this.autoLogin(autoLoginGuid);
      return;
    }

    let reason: number;
    this.route.queryParams.subscribe((params) => {
      reason = params['r'];
      if (reason == 1) {
        this.loginInfo = 'Your session has expired or you are not authorised to complete the last action. Please sign in again';
      }
    });
  }

  private autoLogin(autoLoginGuid: string) {
    this.auth
      .loginWithGuid(autoLoginGuid)
      .then((response: AuthResponse) => {
        this.handleLoginResponse(response);
      })
      .catch(() => {
        this.isError = true;
        this.setErrorMessage('An unknown error has occurred.');
      });
  }

  get username(): AbstractControl {
    return this.dataForm.controls['username'];
  }
  get password(): AbstractControl {
    return this.dataForm.controls['password'];
  }

  onSubmit(): void {
    if (this.formHelperService.isFormValid(this.dataForm)) {
      this.isSigningIn = true;
      this.auth
        .login(this.dataForm.controls['username'].value, this.dataForm.controls['password'].value)
        .then((response: AuthResponse) => {
          this.isSigningIn = false;
          this.handleLoginResponse(response);
        })
        .catch((error) => {
          this.isSigningIn = false;
          this.isError = true;
          this.setErrorMessage('An unknown error has occurred');
          console.error(error);
        });
    }
  }

  private handleLoginResponse(response: AuthResponse) {
    if (response.isError) {
      this.handleLoginError(response);
    } else {
      this.reset();
      this.usersService.resetPermissions();
      this.handleLoginSuccess(response);
    }
  }

  private handleLoginError(response: AuthResponse) {
    if (response.errorType == 'invalid_mfa_code') {
      this.showFirstCard = false;
      this.showAuthCard = true;
      this.showCompanyCard = false;
    }
    else {
      this.isError = response.isError;
      this.setErrorMessage(response.errorMessage);
    }
  }

  setErrorMessageEvent(event: string) {
    this.isError = true;
    this.serverErrorMessage = event;
  }

  private setErrorMessage(errorMessage: string) {
    this.serverErrorMessage = errorMessage;
  }

  private handleLoginSuccess(response: AuthResponse) {
    this.auth.loggedInUserId = response.data['userId'];
    this.auth.loggedInUserName = response.data['userName'];
    this.auth.loggedInFullName = response.data['fullName'];
    this.auth.companyCount = +response.data['companyCount'];

    this.cookieService.setLoggedInUserId(this.auth.loggedInUserId);
    this.cookieService.setLoggedInUserName(this.auth.loggedInUserName);
    this.cookieService.setLoggedInFullName(this.auth.loggedInFullName);
    this.cookieService.setKeyLoggedInCompanyCount(this.auth.companyCount);

    this.setAuthCompanyData(response);

    if (response.data['companyCount'] > 1) {
      this.displayPasswordReset = false;
      this.userId = this.auth.loggedInUserId;

      this.contactService.getUserCompanyLookupData().then((data: UserCompanyLookupDataModel) => {
        if (data.companyList.items.length == 1) {
          this.auth.companyCount = 1;
          this.cookieService.setKeyLoggedInCompanyCount(this.auth.companyCount);
          this.switchCompany(data.companyList.items[0].id);
        }
        else {
          this.currentSelectedMainContactId = data.currentSelectedMainContactId;
          this.userContactsLookupData = this.formHelperService.createLookupDataWithDataObject(data.companyList);
          this.showFirstCard = false;
          this.showAuthCard = false;
          this.showCompanyCard = true;
        }
      });
    }
    else {
      const redirectUrl = this.auth.getRedirectUrl();
      this.router.navigate([redirectUrl]);
    }
  }

  switchCompany(companyId: number) {
    const updateModel = this.createSwitchCompanyUpdateModel(companyId);
    this.userListService.updateCompanyItem(this.userId, updateModel)
      .then((response: any) => {
      if (response.success == true) {
        this.auth.loginWithToken(this.apiAuth.refreshToken)
          .then((response: AuthResponse) => this.handleSwitchCompanyResponse(response));
      }
    });
  }

  private setAuthCompanyData(response: AuthResponse) {
    this.auth.loggedInContactName = response.data['contactName'];
    this.auth.loggedInCompanyName = response.data['selectedCompanyName'];
    this.auth.loggedInCompanyinboundRoutingNumber = response.data['inboundRoutingNumber'];
    this.auth.loggedInCompanyId = response.data['selectedCompanyId'];

    this.cookieService.setLoggedInContactName(this.auth.loggedInContactName);
    this.cookieService.setLoggedInCompanyName(this.auth.loggedInCompanyName);
    this.cookieService.setLoggedInCompanyInboundRoutingNumber(this.auth.loggedInCompanyinboundRoutingNumber);
    this.cookieService.setKeyLoggedInCompanyId(this.auth.loggedInCompanyId);
  }

  private handleSwitchCompanyResponse(response: AuthResponse) {
    if (response.isError) {
      this.isError = true;
      this.setErrorMessage(response.errorMessage);
      return;
    }
    this.setAuthCompanyData(response);

    this.companyProductListService.companyId = this.auth.loggedInCompanyId;
    this.companyProductListService.getCompanyProductList().then((value) => {
      if (value.length == 0) {
        const redirectUrl = 'hub';
        this.router.navigate([redirectUrl]);
      }
      else {
        const redirectUrl = this.auth.getRedirectUrl();
        this.router.navigate([redirectUrl]);
      }
    });
  }

  private createSwitchCompanyUpdateModel(companyId: number) {
    return new SwitchCompanyLoginModel(
      companyId
    )
  }

  private reset() {
    this.isError = false;
    this.serverErrorMessage = '';
  }

  verifyOtp(event: string) {
    this.auth
    .loginOtp(this.dataForm.controls['username'].value, this.dataForm.controls['password'].value, event)
    .then((response: AuthResponse) => {
      this.handleLoginResponse(response);
    })
    .catch((error) => {
      this.isError = true;
      this.setErrorMessage('An unknown error has occurred');
      console.error(error);
    });
  }

  clearMessage()
  {
    this.reset()
  }

  closeAuth()
  {
    this.showFirstCard = true;
    this.showAuthCard = false;
    this.showCompanyCard = false;
  }
}
